/**
 * Created by marvinruppelt on 23.05.17.
 */
import findInObject from '@wikom/find-in-object';
import { PERMISSION_LEVEL_READ_ACCESS } from '../constants/permissionLevels';
import * as NUTZERGRUPPEN from '../constants/nutzergruppen';
export var checkAccess = function (user, category, level) {
    if (level === void 0) { level = PERMISSION_LEVEL_READ_ACCESS; }
    if (user.nutzergruppe === NUTZERGRUPPEN.GROUP_ADMIN)
        return true;
    var access_level = findInObject(category, user.berechtigungen);
    return !(access_level === null || access_level === 0 || access_level < level);
};
export var betriebsauswahlAktiv = function (user) { return ((user.hasOwnProperty('betriebe') && user.betriebe.length !== 1) || user.nutzergruppe === NUTZERGRUPPEN.GROUP_ADMIN || user.nutzergruppe === NUTZERGRUPPEN.GROUP_LWK); };
export var hasBetrieb = function (user) { return (user.hasOwnProperty('betrieb') && user.betrieb !== null); };
export var istGenossenschaft = function (user) {
    var betriebsart_ezz = [2, 3];
    var betriebsart = parseInt(findInObject('betrieb.betriebsart', user));
    return ((betriebsart_ezz.indexOf(betriebsart) > -1));
};
export var getAccessHelper = function (user) { return function (category) { return checkAccess(user, category); }; };
export var isGuest = function (user) { return findInObject('isGuest', user) === true; };
